export default "__VITE_ASSET__BybzOPsY__"